import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "gls_auth_token";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = () => localStorage.getItem(TOKEN_KEY);

  const authHeaders = () => {
    const t = token();
    return t ? { Authorization: `Bearer ${t}` } : {};
  };

  const fetchMe = useCallback(async () => {
    const t = token();
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const r = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } });
      setUser(r.data);
    } catch { localStorage.removeItem(TOKEN_KEY); setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.access_token);
    setUser(r.data.user);
    return r.data;
  };

  // One-click sign-in from a welcome email — redeems a server-issued token.
  const magicLogin = async (magicToken) => {
    const r = await axios.post(`${API}/auth/magic-login`, { token: magicToken });
    localStorage.setItem(TOKEN_KEY, r.data.access_token);
    setUser(r.data.user);
    return r.data;
  };

  const register = async (email, password, name) => {
    const r = await axios.post(`${API}/auth/register`, { email, password, name });
    localStorage.setItem(TOKEN_KEY, r.data.access_token);
    setUser(r.data.user);
    return r.data;
  };

  const logout = async () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
    try { await axios.post(`${API}/auth/logout`); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, magicLogin, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
